if (!window.customElements.get('product-carousel')) {
    class ProductCarousel extends HTMLElement {
        constructor() {
            super();
            console.log('Carousel', this)
            this.sectionId = this.dataset.sectionId
            this.gap = this.dataset.gap
            this.number_per_view = this.dataset.numberPerView
            this.mobile_number_per_view = this.dataset.mobileNumberPerView
            this.padding_right_mobile = this.dataset.paddingRightMobile
        }
  
        connectedCallback() {
          this.initializeSplide()
        }
  
        initializeSplide() {
        console.log('here')
        this.splide = this.querySelector(`#carousel-${this.sectionId}`)
        console.log(this.splide)
        var splide = new Splide(this.splide, {
            perPage: this.number_per_view,
            gap: Number(this.gap),
            pagination: false,
            rewind: false,
            arrows: false,
            drag: false,
            breakpoints: {
                800: {
                    drag: true,
                    perPage: 2,
                    gap: 10,
                    padding: {
                        right: this.padding_right_mobile,
                    },
                },
            },
        });
        splide.mount();
    }
    }
    customElements.define('product-carousel', ProductCarousel);
  }